import React, {useContext, useEffect, useMemo } from 'react'
import { Page, Text, View, Document, PDFViewer, Image, PDFDownloadLink, BlobProvider} from '@react-pdf/renderer';
import { v4 as uuid } from 'uuid';
import UserContext from '../../../context/Globales/UserContext';
import moment from 'moment';
import { Divider } from '@material-ui/core';

const IcpdfProtestoModal = () => {

    const  { datoICMODAL } = useContext(UserContext);
    
    
    const [DatosDetalleImpagospdf] = React.useState(datoICMODAL.RegistrosMorosidadesYProtestos?.Protestos);
    const [DatosDetalleImpagospdfSinacofi] = React.useState(datoICMODAL.RegistrosMorosidadesYProtestos?.ProtestosSinacofi);
    moment.locale('spanish');
    const Fecha = moment().format('LLLL'); // FORMATO: Domingo 15 Julio 2012 11:01

    const TblProtestopdfResumen = (<>
        {DatosDetalleImpagospdf != null ?
         <View style={{ width: '100%' }}>

            <View style={{ flexDirection: 'row', fontSize: 9, backgroundColor: '#e6e6e6', color: 'black' }}>

                    <Text style={{ width: '30%', height: '25px', padding: '1,10', textAlign: 'center' }}>Cant. Documentos</Text>
                    <Text style={{ width: '30%', height: '25px', textAlign: 'center' }}>Fecha más Reciente</Text>
                    <Text style={{ width: '40%', height: '25px', textAlign: 'right' }}>Monto Total</Text>
                  

                </View>
                    <View style={{ flexDirection: 'row', fontSize: 9 }} key={uuid()}>
                        
                        <Text style={{ width: '30%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datoICMODAL.DetallesMorosidadesYProtestos?.Protestos?.NumeroDocumentos}</Text>
                        <Text style={{ width: '30%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datoICMODAL.DetallesMorosidadesYProtestos?.Protestos?.FechaMasReciente}</Text>
                        <Text style={{ width: '40%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'right' }}>{datoICMODAL.DetallesMorosidadesYProtestos?.Protestos?.MontoTotal}</Text>

                    </View>
       

            </View>

        : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN  </Text>}</>);


        const TblProtestopdfResumenSinacofi = (<>
            {DatosDetalleImpagospdfSinacofi != null ?
             <View style={{ width: '100%' }}>

                <View style={{ flexDirection: 'row', fontSize: 9, backgroundColor: '#e6e6e6', color: 'black' }}>

                        <Text style={{ width: '30%', height: '25px', padding: '1,10', textAlign: 'center' }}>Cant. Documentos</Text>
                        <Text style={{ width: '30%', height: '25px', textAlign: 'center' }}>Fecha más Reciente</Text>
                        <Text style={{ width: '40%', height: '25px', textAlign: 'right' }}>Monto Total</Text>
                      

                    </View>
                        <View style={{ flexDirection: 'row', fontSize: 9 }} key={uuid()}>
                            
                            <Text style={{ width: '30%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datoICMODAL.Resumenes?.ProtestosVigentesSinacofi?.TotalDocumentos}</Text>
                            <Text style={{ width: '30%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>--</Text>
                            <Text style={{ width: '40%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'right' }}>--</Text>

                        </View>
           

                </View>

            : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN  </Text>}</>);



const TblProtestoDetallePdf =(
    <>
    {DatosDetalleImpagospdf != null ?
        <View style={{ width: '100%' }}>


            <View style={{ flexDirection: 'row', fontSize: 9, backgroundColor: '#e6e6e6', color: 'black' }}>

                <Text style={{ width: '5%', height: '25px', padding: '1,10', textAlign: 'center' }}>#</Text>
                <Text style={{ width: '15%', height: '25px', textAlign: 'center' }}>Tipo Documento.</Text>
                <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>F. Venc</Text>
                <Text style={{ width: '30%', height: '25px', textAlign: 'left' }}>Librador</Text>
                <Text style={{ width: '13%', height: '25px', textAlign: 'center' }}>Tipo de deudad</Text>
                <Text style={{ width: '8%', height: '25px', textAlign: 'center' }}>Moneda</Text>
                <Text style={{ width: '18%', height: '25px', textAlign: 'right' }}>Monto</Text>

            </View>


            {DatosDetalleImpagospdf.map((datadetallprotestopdf, idprotestopdf) =>(

                <View style={{ flexDirection: 'row', fontSize: 9 }} key={idprotestopdf}>
                    <Text style={{ width: '5%', borderBottom: '1 solid #e6e6e6 ', height: '25px', padding: '1,10', textAlign: 'center' }}>{idprotestopdf + 1}</Text>
                    <Text style={{ width: '15%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datadetallprotestopdf.TipoDocumento}</Text>
                    <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datadetallprotestopdf.FechaVencimientoProtesto}</Text>
                    <Text style={{ width: '30%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{datadetallprotestopdf.Librador}</Text>
                    <Text style={{ width: '13%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datadetallprotestopdf.TipoDeuda}</Text>
                    <Text style={{ width: '8%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datadetallprotestopdf.Moneda}</Text>
                    <Text style={{ width: '18%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'right' }}> {datadetallprotestopdf.Monto}</Text>

                </View>
            ))}

        </View>

        : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN </Text>}
</>
); 


const TblProtestoDetallePdfSinacofi =(
    <>
    {DatosDetalleImpagospdfSinacofi != null ?
        <View style={{ width: '100%' }}>


            <View style={{ flexDirection: 'row', fontSize: 9, backgroundColor: '#e6e6e6', color: 'black' }}>

                <Text style={{ width: '5%', height: '25px', padding: '1,10', textAlign: 'center' }}>#</Text>
                <Text style={{ width: '15%', height: '25px', textAlign: 'center' }}>Tipo Documento.</Text>
                <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>F. Venc</Text>
                <Text style={{ width: '38%', height: '25px', textAlign: 'left' }}>Librador</Text>
                <Text style={{ width: '13%', height: '25px', textAlign: 'center' }}>Tipo de deudad</Text>
                <Text style={{ width: '13%', height: '25px', textAlign: 'center' }}>Moneda</Text>
                <Text style={{ width: '18%', height: '25px', textAlign: 'right' }}>Monto</Text>

            </View>


            {DatosDetalleImpagospdfSinacofi.map((datadetallprotestopdf, idprotestopdf) =>(

                <View style={{ flexDirection: 'row', fontSize: 9 }} key={idprotestopdf}>
                    <Text style={{ width: '5%', borderBottom: '1 solid #e6e6e6 ', height: '25px', padding: '1,10', textAlign: 'center' }}>{idprotestopdf + 1}</Text>
                    <Text style={{ width: '15%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datadetallprotestopdf.TipoDocumento}</Text>
                    <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datadetallprotestopdf.FechaVencimientoProtesto}</Text>
                    <Text style={{ width: '30%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{datadetallprotestopdf.Librador}</Text>
                    <Text style={{ width: '13%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datadetallprotestopdf.TipoDeuda}</Text>
                    <Text style={{ width: '8%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{datadetallprotestopdf.Moneda}</Text>
                    <Text style={{ width: '18%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'right' }}> {datadetallprotestopdf.Moneda} {datadetallprotestopdf.Monto}</Text>

                </View>
            ))}

        </View>

        : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN </Text>}
</>
); 

const ReporteProtestoPdf =()=>(
     
    <Document >
        
        <Page size="letter" style={{ paddingTop: 15, paddingBottom: 40, paddingHorizontal: 20 }}>
            <View>


                <Image src={process.env.PUBLIC_URL + '/static/imagen/logonewp.png'} style={{ width: '100%', padding: '2' }} fixed />
              
                <Text style={{ fontSize: 9, textAlign: 'right' }} fixed>FECHA IMPRESIÓN: { Fecha }</Text>
                <Text style={{ fontSize: 10, textAlign: 'right' }} render={({ pageNumber, totalPages }) => (`PÁGINA ${pageNumber} / ${totalPages}`)} fixed />
               
                <View fixed>
                    <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#bbdefb', color: 'black', marginTop: 8, padding: '5,15' }}  >{datoICMODAL.Identificacion?.IsEmpresa ? datoICMODAL.DetalleIdentificacionEmpresa?.Nombre : datoICMODAL.Identificacion?.Nombre} RUT {datoICMODAL.Identificacion?.Rut}</Text>
                </View>

                <View style={{ width: '60%' }}>
                    <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>RESUMEN PROTESTO</Text>
                    {TblProtestopdfResumen}
                </View>

                <View style={{ width: '100%' }}>
                    <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>DETALLE</Text>
                    {TblProtestoDetallePdf}
                </View>

                <View style={{ width: '60%' }}>
                    <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>RESUMEN PROTESTO SINACOFI</Text>
                    {TblProtestopdfResumenSinacofi}
                </View>

                <View style={{ width: '100%' }}>
                    <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>DETALLE</Text>
                    {TblProtestoDetallePdfSinacofi}
                </View>

                <View style={{ width: '50%', alignContent: 'left' }}>
                {/*<Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/qrPortacheque.png'} style={{ width: '30%', padding: '5' }} />*/}
                <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}  >Nro. FOLIO: {datoICMODAL.ID} - {uuid(datoICMODAL.ID)}</Text>
                </View>


            </View>


        </Page>

    </Document>

); 





return useMemo(
    ()=>(
    <div>

    
    <PDFDownloadLink  document={<ReporteProtestoPdf />} fileName={`${uuid()}.pdf`}>

    {({ blob, url, loading, error }) => (loading ? <h2 style={{ textAlign: 'center', fontSize: '18px' }}>Ten paciencia, estamos generando el PDF... </h2> : <h2 style={{ textAlign: 'center', fontSize: '22px' }}>DESCARGAR ARCHIVO PDF</h2>)}
      
    </PDFDownloadLink>
        
       

    </div>
),[]

);
}

export default IcpdfProtestoModal;
